import "./AboutMe.css";

function AboutMe() {
  return (
    <div id="about" className="about-me">
      <h1>About Me</h1>
      <p>
        My name is Prakhar Gaba, and I hail from Jaipur. At 19 years old, my
        fascination with tech and the IT industry has been a driving force since
        childhood. Exploring the inner workings of technology, I embarked on a
        journey into programming, eager to unravel its complexities. Today, I
        stand as a Tech Enthusiast and MERN Developer, passionate about
        discovering innovative technologies like Web3, AR-based applications,
        and blockchain. Proficient in the MERN stack, I also delve into C++
        programming, dedicated to continuous learning and eager to seize new
        opportunities in this dynamic field of technology.
      </p>
    </div>
  );
}
export default AboutMe;
